
































import { addWeeks, format, subDays } from "date-fns";
import { cloneDeep, range } from "lodash";
import { Component, Vue, Prop } from "vue-property-decorator";

import ServiceTaskCell, {
  Props as ServiceTaskCellProps
} from "../components/ServiceTaskCell.vue";
import VServiceTaskTable from "./VServiceTaskTable.vue";
import VDatePeriod from "../../../components/VDatePeriod.vue";
import DateHoliday from "date-holidays";

export interface Props {
  schedule: Schedule;
  perPage?: number;
}

interface Schedule {
  name: string;
  date: Date;
  days: Day[];
}

interface Day {
  date: string;
  rawDate: string;
  items: (ServiceTaskCellProps | null)[];
}

/**
 * 印刷用にページを区切る工程表出力
 */
@Component({
  components: {
    VDatePeriod,
    VServiceTaskTable,
    ServiceTaskCell
  }
})
export default class PrintServiceSchedule extends Vue {
  @Prop({ required: true }) schedule!: Schedule;
  @Prop({ default: 4 }) perPage!: number;

  get maxRows(): number {
    return this.schedule.days.reduce(
      (max, d) => Math.max(d.items.length, max),
      0
    );
  }

  get pages(): number {
    return Math.ceil(this.maxRows / this.perPage);
  }

  get firstDate(): string {
    return format(this.schedule.date, "M/d(E)");
  }

  get finalDate(): string {
    return format(subDays(addWeeks(this.schedule.date, 1), 1), "M/d(E)");
  }

  getIndexRange(page: number): number[] {
    const firstIndex = this.perPage * (page - 1);
    return range(firstIndex, firstIndex + this.perPage);
  }

  holiday = new DateHoliday("JP");

  isHoliday(date: string): boolean {
    const copyHoliday = cloneDeep(this.holiday);
    const day = copyHoliday.isHoliday(new Date(date));

    return Array.isArray(day) && day.length > 0;
  }
  isWeekend(date: string): boolean {
    // Get the day of the week (0 for Sunday, 6 for Saturday)
    const day = new Date(date).getDay();
    return day === 0 || day === 6;
  }
  highlightDateClass(date: string): string {
    if (this.isHoliday(date)) {
      return "holiday";
    }
    if (this.isWeekend(date)) {
      return "weekend";
    }
    return "";
  }
}
